import { render, staticRenderFns } from "./Radarr.vue?vue&type=template&id=545a307c&scoped=true&"
import script from "./Radarr.vue?vue&type=script&lang=js&"
export * from "./Radarr.vue?vue&type=script&lang=js&"
import style0 from "./Radarr.vue?vue&type=style&index=0&id=545a307c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545a307c",
  null
  
)

export default component.exports